import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { BFLoader } from '@components/common/loader/main';
import AdvancedFiltersDrawer from '../advanced_filters/main';
import LabelsDrawer from '../labels/main';

import './styles/main.scss';

const FiltersDrawer = (props) => {
  const {
    activateLabel,
    activeLabelKey,
    labels,
    filters,
    filtersDrawerOpen,
    searchableThings,
    selectedAssetKeys,
    toggleFiltersDrawer,
    updateFilters,
    refresh,
  } = props;

  const advancedFiltersClass = filtersDrawerOpen === "advanced-filters" ? "open" : "closed";

  return (
    <nav className={classnames('filters-drawer', { open: filtersDrawerOpen !== 'none' })}>
      {labels && labels.labelsTree && Object.keys(labels.labelsTree).length ? (
        <LabelsDrawer
          activateLabel={activateLabel}
          activeLabelKey={activeLabelKey}
          labels={labels}
          filtersDrawerOpen={filtersDrawerOpen}
          selectedAssetKeys={selectedAssetKeys}
          toggleFiltersDrawer={toggleFiltersDrawer}
        />
      ) : null}
      <div className={`advanced-filters-container ${advancedFiltersClass}`}>
        {!searchableThings ? (
          <div className="loader-container">
            <BFLoader />
          </div>
        ) : (
          <AdvancedFiltersDrawer
            filters={filters}
            filtersDrawerOpen={filtersDrawerOpen}
            searchableThings={searchableThings}
            selectedAssetKeys={selectedAssetKeys}
            toggleFiltersDrawer={toggleFiltersDrawer}
            updateFilters={updateFilters}
            refresh={refresh}
          />
        )}
      </div>
    </nav>
  );
};

FiltersDrawer.propTypes = {
  activateLabel: PropTypes.func.isRequired,
  activeLabelKey: PropTypes.string,
  labels: PropTypes.shape({}),
  filters: PropTypes.shape({}).isRequired,
  filtersDrawerOpen: PropTypes.oneOf(['labels', 'advanced-filters', 'none']).isRequired,
  searchableThings: PropTypes.shape({}),
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
  toggleFiltersDrawer: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  refresh: PropTypes.func,
};

FiltersDrawer.defaultProps = {
  activeLabelKey: null,
  labels: {},
  searchableThings: null,
  refresh: () => {},
};

export default FiltersDrawer;
